import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../../types/types';
import {
    ESplitSettingsTabs,
    splitSettingsTabClicked
} from '../../../../../../../../../middlewares/segment/trackEntities/boardEvents';

export const onClick = (
    ownOnClick?: () => void
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        // console.log('segment email notifications button onClick');
        if (ownOnClick) ownOnClick();
        dispatch(splitSettingsTabClicked(ESplitSettingsTabs.EMAIL_NOTIFICATIONS));
    };
    return action;
};
